"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _Link = _interopRequireDefault(require("../Link/Link"));

var _constants = require("../utils/constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _icon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/icon.css") : void 0);

var _messageStrip = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/message-strip.css") : void 0);

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; (0, _forEach.default)(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context3; (0, _forEach.default)(_context3 = ownKeys(Object(source))).call(_context3, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _objectSpread(_objectSpread({}, _icon.default), _messageStrip.default));
/** A **MessageStrip** provides a message within the application that is
 * color-coded to emphasize the level of urgency. */

var MessageStrip = function MessageStrip(props) {
  var _context, _classnames;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var onCloseClicked = props.onCloseClicked,
      buttonProps = props.buttonProps,
      type = props.type,
      link = props.link,
      linkProps = props.linkProps,
      linkText = props.linkText,
      localizedText = props.localizedText,
      noGlyph = props.noGlyph,
      dismissible = props.dismissible,
      children = props.children,
      className = props.className,
      cssNamespace = props.cssNamespace,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["onCloseClicked", "buttonProps", "type", "link", "linkProps", "linkText", "localizedText", "noGlyph", "dismissible", "children", "className", "cssNamespace"]);

  var closeMessageStripHandler = function closeMessageStripHandler(e) {
    setActive(false);
    onCloseClicked(e);
  };

  var MessageStripClasses = classnames("".concat(cssNamespace, "-message-strip"), (_classnames = {}, (0, _defineProperty3.default)(_classnames, "".concat(cssNamespace, "-message-strip--dismissible"), dismissible), (0, _defineProperty3.default)(_classnames, "".concat(cssNamespace, "-message-strip--no-icon"), noGlyph), (0, _defineProperty3.default)(_classnames, (0, _concat.default)(_context = "".concat(cssNamespace, "-message-strip--")).call(_context, type), !!type), _classnames), className);
  var generatedAlertId = (0, _useUniqueId.default)();
  var alertId = (otherProps === null || otherProps === void 0 ? void 0 : otherProps.id) || generatedAlertId;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, active && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    className: MessageStripClasses,
    id: alertId,
    role: "alert"
  }), dismissible && /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, buttonProps, {
    "aria-controls": alertId,
    "aria-label": localizedText.close,
    className: classnames("".concat(cssNamespace, "-message-strip__close")),
    compact: true,
    glyph: "decline",
    onClick: closeMessageStripHandler,
    option: "transparent"
  })), /*#__PURE__*/_react.default.createElement("p", {
    className: classnames("".concat(cssNamespace, "-message-strip__text"))
  }, children, link && /*#__PURE__*/_react.default.createElement(_Link.default, (0, _extends2.default)({}, linkProps, {
    href: link
  }), linkText, ' '))));
};

MessageStrip.displayName = 'MessageStrip';
process.env.NODE_ENV !== "production" ? MessageStrip.propTypes = {
  /** Additional props to be spread to the `<button>` element */
  buttonProps: _propTypes.default.object,

  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to show a dismiss button */
  dismissible: _propTypes.default.bool,

  /** Value to be applied to the anchor\'s `href` attribute */
  link: _propTypes.default.string,

  /** Additional props to be spread to the link\'s `<a>` element */
  linkProps: _propTypes.default.object,

  /** Localized display text of the link */
  linkText: _propTypes.default.string,

  /** Localized text to be updated based on location/language */
  localizedText: _CustomPropTypes.default.i18n({
    /** Value for aria-label on the close <button> element */
    close: _propTypes.default.string
  }),

  /** Set to **true** to disable the state icon */
  noGlyph: _propTypes.default.bool,

  /** Sets the variation of the component. Primarily used for styling:
  'warning',
  'error',
  'success',
  'information'*/
  type: _propTypes.default.oneOf(_constants.MESSAGESTRIP_TYPES),

  /**
   * Callback function; triggered when a dismissible MessageStrip's close button is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {void}
  */
  onCloseClicked: _propTypes.default.func
} : void 0;
MessageStrip.defaultProps = {
  localizedText: {
    close: 'Close'
  },
  onCloseClicked: function onCloseClicked() {}
};

var _default = (0, _withStyles.default)(MessageStrip);

exports.default = _default;